(() => {
  const mobile = window.matchMedia('(max-width: 767px)');
  const storageKey = 'bnails-cart-recommendations-dismissed';
  const placements = new Map();
  const carousels = new Map();
  const noteVisibility = new Map();
  let dismissed = false;
  try { dismissed = sessionStorage.getItem(storageKey) === '1'; } catch (_) {}

  function relocate(node, parent, before = null) {
    if (!node || !parent) return;
    if (!placements.has(node)) placements.set(node, { parent: node.parentNode, next: node.nextSibling });
    if (node.parentNode !== parent || (before && node.nextSibling !== before)) parent.insertBefore(node, before);
  }

  function restore() {
    placements.forEach(({ parent, next }, node) => {
      if (node.isConnected && parent.isConnected) parent.insertBefore(node, next?.parentNode === parent ? next : null);
    });
    placements.clear();
  }

  function preparePayments(root) {
    root.querySelectorAll('[data-additional-checkout-button]').forEach(node => {
      node.classList.toggle('additional-checkout-buttons--vertical', !mobile.matches);
    });
  }

  function syncRecommendationSlider(drawer) {
    carousels.forEach((state, slider) => {
      if (!slider.element.isConnected) carousels.delete(slider);
      else if (!mobile.matches) {
        slider.options.draggable = state.draggable;
        slider.options.accessibility = state.accessibility;
        slider.updateDraggable();
        if (state.tabindex === null) slider.element.removeAttribute('tabindex');
        else slider.element.setAttribute('tabindex', state.tabindex);
        slider.resize();
        slider.select(state.selectedIndex, false, true);
        carousels.delete(slider);
      }
    });
    if (!mobile.matches) return;
    const element = drawer.querySelector('[data-pair-products]');
    const slider = element && window.themeVendor?.Flickity?.data(element);
    if (!slider) return;
    if (!carousels.has(slider)) carousels.set(slider, {
      draggable: slider.options.draggable,
      accessibility: slider.options.accessibility,
      selectedIndex: slider.selectedIndex,
      tabindex: element.getAttribute('tabindex')
    });
    slider.options.draggable = false;
    slider.options.accessibility = false;
    slider.updateDraggable();
    slider.select(0, false, true);
    element.removeAttribute('tabindex');
    element.querySelectorAll('[data-upsell-holder]').forEach((card, index) => card.setAttribute('aria-hidden', index === 0 ? 'false' : 'true'));
  }

  function sync() {
    const drawer = document.querySelector('[data-cart-drawer]');
    if (!drawer) return;
    const template = drawer.querySelector('[data-cart-drawer-template]');
    if (template) preparePayments(template.content);
    const body = drawer.querySelector('[data-cart-drawer-body]');
    if (!body) return;
    preparePayments(drawer);
    drawer.classList.toggle('bnails-cart-mobile', mobile.matches);
    drawer.classList.toggle('bnails-cart-upsell-dismissed', dismissed);
    if (!mobile.matches) {
      restore();
      noteVisibility.forEach((hidden, notes) => { if (notes.isConnected) notes.hidden = hidden; });
      noteVisibility.clear();
      syncRecommendationSlider(drawer);
      return;
    }
    const head = drawer.querySelector('.cart-drawer__head');
    const message = drawer.querySelector('[data-cart-message]');
    const pair = drawer.querySelector('[data-pair-products-holder]');
    const notes = drawer.querySelector('.cart__widget__wrapper');
    const total = drawer.querySelector('[data-cart-total-price]');
    const subtotal = drawer.querySelector('[data-bnails-cart-subtotal]');
    if (message && head) relocate(message, drawer, body);
    relocate(pair, body);
    relocate(notes, body);
    relocate(total, subtotal);
    notes?.querySelectorAll('textarea, input, select').forEach(field => field.setAttribute('form', 'BNAILSCartDrawerForm'));
    const hasItems = !!drawer.querySelector('[data-items-holder] [data-cart-item]');
    if (notes) {
      if (!noteVisibility.has(notes)) noteVisibility.set(notes, notes.hidden);
      notes.hidden = !hasItems || noteVisibility.get(notes);
    }
    body.setAttribute('data-scroll-lock-scrollable', '');
    const hasRecommendation = hasItems && !!pair?.querySelector('[data-upsell-holder]');
    pair?.classList.toggle('bnails-cart-no-recommendation', !hasRecommendation);
    syncRecommendationSlider(drawer);
    message?.querySelectorAll('[data-cart-message-progress]').forEach(progress => {
      const width = Number.parseFloat(progress.style.getPropertyValue('--progress-width'));
      const value = message.classList.contains('is-success') ? 100 : Math.max(0, Math.min(100, Number.isFinite(width) ? width : 0));
      progress.value = value;
      progress.style.setProperty('--bnails-progress-width', `${value}%`);
    });
  }

  document.addEventListener('click', event => {
    const button = event.target.closest('[data-bnails-dismiss-upsell]');
    if (!button || !mobile.matches) return;
    event.preventDefault();
    dismissed = true;
    try { sessionStorage.setItem(storageKey, '1'); } catch (_) {}
    const drawer = button.closest('[data-cart-drawer]');
    drawer?.classList.add('bnails-cart-upsell-dismissed');
    drawer?.querySelector('.cart__checkout')?.focus({ preventScroll: true });
  });
  ['theme:cart:loaded', 'theme:cart:added', 'theme:cart:open'].forEach(name => document.addEventListener(name, sync));
  mobile.addEventListener('change', sync);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', sync);
  else sync();
})();
